(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/search-results/search-results-list.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/search-results/search-results-list.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const ListGroup = svs.ui.ReactListGroup.ListGroup;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const ResultItem = svs.grassroots.components.search_results.ResultItem;
const ReceiverBottomSheet = svs.grassroots.components.receiver.ReceiverBottomSheet;
const SearchResultsList = _ref => {
  let resultPage = _ref.resultPage,
    receivers = _ref.receivers,
    searchterm = _ref.searchterm;
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  const _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    receiver = _React$useState4[0],
    setReceiver = _React$useState4[1];
  const history = useHistory();

  const onOpenBottomSheetHandler = (receiver, event) => {
    event.preventDefault();
    event.stopPropagation();
    setReceiver(receiver);
    setOpen(true);
    if (!resultPage) {
      window.history.replaceState(null, null, "".concat(svs.core.data.baseUrl, "/forening/").concat(receiver.id));
    }
  };

  const onCloseBottomSheetHandler = () => {
    setOpen(false);
    setReceiver({});
    if (!resultPage) {
      history.replace("/sok?q=".concat(encodeURIComponent(searchterm)));
    }
  };
  return React.createElement("div", null, open && React.createElement(ReceiverBottomSheet, {
    close: onCloseBottomSheetHandler,
    isOpen: open,
    receiver: receiver
  }), React.createElement(ListGroup, null, receivers.map(receiver => React.createElement(ResultItem, {
    key: receiver.id,
    onClick: onOpenBottomSheetHandler,
    receiver: receiver
  }))));
};
svs.grassroots.components.search_results.SearchResultsList = SearchResultsList;

 })(window);